import { Sparkles, ChevronRight, X } from 'lucide-react';
import type { ModelPillVM } from '../types';

// Selected-model pills + recommend/details controls (DC §4.5).
export function ModelSelector({
  pills,
  recommendedCount,
  onRemove,
  onUseRecommended,
  onOpenModelModal,
}: {
  pills: ModelPillVM[];
  recommendedCount: number;
  onRemove: (id: string) => void;
  onUseRecommended: () => void;
  onOpenModelModal: () => void;
}) {
  return (
    <div style={{ marginTop: 22, paddingTop: 20, borderTop: '1px solid var(--border)' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 10,
          flexWrap: 'wrap',
          marginBottom: 12,
        }}
      >
        <span style={{ fontSize: 13, color: 'var(--muted-foreground)' }}>
          Using <span style={{ fontWeight: 600, color: 'var(--foreground)' }}>{recommendedCount} recommended</span> AI models
        </span>
        <button
          type="button"
          onClick={onOpenModelModal}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 3,
            background: 'none',
            border: 'none',
            padding: 0,
            fontFamily: 'inherit',
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--signal-blue)',
            cursor: 'pointer',
          }}
        >
          Customize <ChevronRight style={{ width: 13, height: 13 }} />
        </button>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        {pills.map((m) => (
          <span
            key={m.id}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              height: 30,
              padding: '0 11px',
              borderRadius: 8,
              background: 'var(--card)',
              border: '1px solid var(--border)',
              fontSize: 12,
              fontWeight: 500,
              color: 'var(--foreground)',
            }}
          >
            <span style={{ width: 7, height: 7, borderRadius: 99, background: m.dot, flexShrink: 0 }} />
            {m.label}
            <span
              role="button"
              onClick={() => onRemove(m.id)}
              style={{ display: 'inline-flex', cursor: 'pointer', marginLeft: 1 }}
            >
              <X style={{ width: 13, height: 13, color: 'var(--muted-foreground)' }} />
            </span>
          </span>
        ))}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginTop: 13, flexWrap: 'wrap' }}>
        <button
          type="button"
          onClick={onUseRecommended}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            height: 30,
            padding: '0 12px',
            borderRadius: 8,
            background: 'var(--spectral-violet-10)',
            border: '1px solid var(--spectral-violet-20)',
            color: 'var(--spectral-violet)',
            fontSize: 12,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          <Sparkles style={{ width: 13, height: 13 }} /> Use recommended
        </button>
        <button
          type="button"
          onClick={onOpenModelModal}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            height: 30,
            padding: '0 12px',
            borderRadius: 8,
            background: 'var(--signal-blue-10)',
            border: '1px solid var(--signal-blue-20)',
            color: 'var(--signal-blue)',
            fontSize: 12,
            fontWeight: 600,
            fontFamily: 'inherit',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          Model details <ChevronRight style={{ width: 13, height: 13 }} />
        </button>
      </div>
    </div>
  );
}
